import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import type { Asset } from "@/types";

type Params = {
  site_id: string;
  project_id?: string;
};

export function useAssets(params: Params) {
  const query = buildParams(params);

  return useQuery({
    queryKey: ["assets", params],
    queryFn: () => apiFetch<Asset[]>(`/v1/home/assets${query}`),
    enabled: !!params.site_id,
  });
}
